import { Tooltip } from "antd";
import { useState, useEffect, useRef } from "react";
import { CiCircleInfo } from "react-icons/ci";
import styles from './styles.module.css'

const TooltipView = ({ text , clsName}) => {
    const [visible, setVisible] = useState(false);
    const [cls, setCls] = useState (clsName || "dfltStyle")
    const buttonRef = useRef(null);
    // console.log(clsName)
    const handleMouseDown = () => {
        setVisible(true);
    };

    const handleMouseUp = () => {
        setVisible(false);
    };

    useEffect(() => {
        if (clsName === undefined){
            setCls("dfltStyle") 
        }
        const handleClickOutside = (event) => {
            
            if (buttonRef.current && !buttonRef.current.contains(event.target)) {
                setVisible(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <Tooltip
            placement="top"
            title={text}
            color="#fff"
            visible={visible}
            overlayInnerStyle={{ color: '#000' }}
        >
            {/* {console.log(cls)} */}
            <button
                type="button"
                ref={buttonRef}
                className={styles[cls]}
                // style={{ border: 'none', cursor: 'pointer', fontSize: '17px', marginTop: '-3px', color:'#000000',backgroundColor:'#eeeeee'  }}
                // onMouseDown={handleMouseDown}
                // onMouseUp={handleMouseUp}
                // onTouchStart={handleMouseDown}
                // onTouchEnd={handleMouseUp}
                onClick={()=>setVisible(!visible)}
            >
                <CiCircleInfo />
            </button>
        </Tooltip>
    );
};

export default TooltipView;
